import { createFileRoute } from "@tanstack/react-router"
import { SalesForceConfiguration } from "modules/settings/components/integrations/salesForce"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/integrations/salesForce")({
  component: SalesForceConfiguration,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("settings.integrations.salesForce.title"),
    })
  },
})
